import {
  BookingScheduleSearch_Get,
  BookingScheduleSearch_GetTotal,
  BookingScheduleSearchItemFragment
} from "@graphql";
import { BookingSearchStore } from "../BookingSearchStore";

export class BookingScheduleSearchStore extends BookingSearchStore<BookingScheduleSearchItemFragment> {
  constructor() {
    super(BookingScheduleSearch_Get, undefined, (filter) => {
      return BookingScheduleSearch_GetTotal.func(
        { filter },
        { fetchPolicy: "network-only" }
      ).then((x) => x.data.bookingWeeksTotal.total);
    });

    (window as any).bookingScheduleSearchStore = this;
  }
}
